<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useQuery } from '@tanstack/vue-query'

import { getUserConfigOptions } from '@/gen/oas/apiv4/@tanstack/vue-query.gen'
import {
  EDIT_FORM_ROUTES,
  hasVue2Equivalent,
  resolveVue2Path,
  setPreferredFrontend
} from '@/lib/frontendModeMap'

const route = useRoute()
const { t } = useI18n()

const { data: userConfig } = useQuery({
  ...getUserConfigOptions(),
  staleTime: Infinity
})

const visible = computed(() => {
  const mode = userConfig.value?.frontend_mode
  if (mode !== 'all') return false
  const name = route.name as string | undefined
  if (!name) return false
  return !EDIT_FORM_ROUTES.has(name)
})

const target = computed(() => resolveVue2Path(route))
const hasEquivalent = computed(() => hasVue2Equivalent(route.name as string | undefined))

function switchFrontend() {
  if (!target.value) return
  setPreferredFrontend('vue2')
  window.location.assign(target.value)
}
</script>

<template>
  <button
    v-if="visible"
    type="button"
    class="pointer-events-auto rounded-full bg-brand-700 px-4 py-2 text-sm font-semibold text-base-white shadow-lg hover:bg-brand-800 disabled:cursor-not-allowed disabled:bg-gray-warm-300"
    :disabled="!hasEquivalent"
    :title="hasEquivalent ? t('frontend_toggler.to_vue2') : t('frontend_toggler.no_equivalent')"
    @click="switchFrontend"
  >
    {{ hasEquivalent ? t('frontend_toggler.to_vue2') : t('frontend_toggler.no_equivalent') }}
  </button>
</template>
